// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { FirstAccessProvider } from 'hooks/useFirstAccess';
import UserMenu from 'components/layout/userMenuNewOld';

import GenericNavBar from 'newComponents/GenericNavBar';
import { useTour } from 'hooks/useTour';
import { TableWrap } from 'pages/BankSlip/styles';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import YourIdentification from './YourIdentification';
import ModalContent from './ModalContent';
import TheEnd from './TheEnd';

import { TYPE_STEPS } from './enums';
import { Scrollbar, BoxPadding } from './styles';

const AddContract: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeStep, setActiveStep] = useState(1);

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('add-contract');
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  return (
    <GenericNavBar
      selected="nova-empresa"
      withTable
      breadcrump="› Adicionar Nova Empresa"
      intro={() => true}
    >
      <BoxPadding>
        <Scrollbar>
          <FirstAccessProvider>
            <TableWrap
              showTour={
                showTour && tourType === 'add-contract' && tourStep === 1
              }
            >
              {activeStep === TYPE_STEPS.yourIdentification && (
                <YourIdentification
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                  setShowModal={setShowModal}
                />
              )}
              {showTour && tourType === 'add-contract' && tourStep === 1 && (
                <TourBalloon
                  title="Adicionar empresa"
                  content="Aqui você pode informar os dados da empresa que será adicionada."
                  position={{
                    left: '50%',
                    right: '0',
                    top: '50%',
                    arrowPosition: 'none',
                    maxWidth: 300,
                    boxShadow: true,
                  }}
                />
              )}
            </TableWrap>
            {activeStep === TYPE_STEPS.theEnd && (
              <TheEnd activeStep={activeStep} setActiveStep={setActiveStep} />
            )}
          </FirstAccessProvider>
        </Scrollbar>
      </BoxPadding>
      <ModalContent isOpen={showModal} setShowModal={setShowModal} />
    </GenericNavBar>
  );
};

export default AddContract;
